import styled from "styled-components";

export const Item = styled.div<{ $isNew?: boolean }>`
  border-bottom: 1px solid #e0e0e0;
  padding: 10px;
  padding-left: 20px;
  min-height: 70px;
  padding-top: 20px;
  position: relative;
  background-color: ${(props) => (props.$isNew ? "#e7f3ff" : "transparent")};

  h6 {
    font-size: 18px;
  }

  p {
    font-size: 14px;
    font-weight: normal !important;
    margin-top: 10px;
  }
`;

export const Date = styled.span`
  position: absolute;
  top: 0.5;
  right: 15px;
  color: #c4c4c4;
  font-size: 12px;
`;

export const Box = styled.div``;
